// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kTAc5","col":"styles_col__2RHre"};